module.exports = __webpack_public_path__ + "static/media/SIX.4ab164fd.png";